// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"708":"494373b7","863":"1bd5eecc","894":"60c153d8"}[chunkId] + ".js";
};